import React from "react";
import { Button, Col, Form, Row, Modal, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import { editPlantillaCuestionariosCategorias } from "../../../../redux/climalaboral/plantillaCuestionario/action";

const Categorie = (props) => {
  const schema = Yup.object().shape({
    objeto: Yup.string().required("**Campo requerido"),
  });

  const dispatch = useDispatch();

  const onSubmitCategoria = (req) => {
    req.nombre = props.plantilla.nombre;
    req.descripcion = props.plantilla.descripcion;
    dispatch(
      editPlantillaCuestionariosCategorias(
        req,
        props.plantilla.id,
        props.setShowModalCategoria,
        props.plantilla,
        props.setPlantilla
      )
    );
  };

  return (
    <>
      <Modal
        show={props.showModalCategoria}
        onHide={() => props.setShowModalCategoria(false)}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmitCategoria}
          initialValues={{
            objeto: props.plantilla ? props.plantilla.objeto : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Editar Categoría</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Form.Group as={Col}>
                    <Row className="align-items-end">
                      <Col sm={props.categoryLoading ? "10" : "12"}>
                        <Form.Label className="ml-2">Categoría:</Form.Label>
                        <Form.Control
                          as="select"
                          id="objeto"
                          name="objeto"
                          isInvalid={touched.objeto && errors.objeto}
                          isValid={touched.objeto && !errors.objeto}
                          onBlur={handleBlur("objeto")}
                          onChange={handleChange}
                          value={values.objeto}
                          className="rounded-pill"
                          placeholder="Categoría"
                        >
                          <option key="" value="" selected disabled>
                            Seleccione una categoria
                          </option>
                          {props.category
                            ? props.category
                                .sort((a, b) => {
                                  if (a.nombre && b.nombre) {
                                    if (
                                      a.nombre.toLowerCase() ===
                                      b.nombre.toLowerCase()
                                    ) {
                                      return 0;
                                    }
                                    if (
                                      a.nombre.toLowerCase() <
                                      b.nombre.toLowerCase()
                                    ) {
                                      return -1;
                                    }
                                  }
                                  return 1;
                                })
                                .map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id ? item.id : ""}
                                  >
                                    {item.nombre
                                      ? item.nombre.toUpperCase()
                                      : ""}
                                  </option>
                                ))
                            : null}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid" className="px-3">
                          **Campo requerido
                        </Form.Control.Feedback>
                      </Col>
                      {props.categoryLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  disabled={props.saveLoader}
                  variant="primary"
                  type="submit"
                >
                  {props.saveLoader && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Categorie;
